import { css } from '@emotion/css';
import * as React from 'react';
import { slate } from '../colors';

const square = css`
  width: 16px;
  height: 16px;
  background: transparent;
  margin: 10% auto;
  position: relative;

  &:after {
    content: 'L';
    position: absolute;
    left: 3px;
    top: -1px;
    font-size: 20px;
    font-weight: 600;
    transform: scaleX(-1) rotate(-45deg);
  }
`;

const Check = (props: { color?: string; [otherOptions: string]: unknown }) => (
  <div className={square} style={{ color: props.color ?? slate }} {...props} />
);

export default Check;
